import { connect } from 'react-redux';
import { setSalespersonId, validateSalespersonId, destroySalespersonId } from 'redux/domain/App';
import toJS from 'shared/components/toJS';
import withAsyncId from 'shared/components/withAsyncId';
import { bindActionCreators } from 'redux';
import ActionMenu from './ActionMenu';

export const mapStateToProps = state => ({
	salespersonId: state.app.get('salespersonId'),
	settings: state.cache.get('settings'),
});

const mapDispatchToProps = dispatch =>
	bindActionCreators({ validateSalespersonId, setSalespersonId, destroySalespersonId }, dispatch);

export default withAsyncId(connect(mapStateToProps, mapDispatchToProps)(toJS(ActionMenu)));
